import React from "react";
import img from "images/prestige.png";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useNavigate } from "react-router-dom";

export default function QualityPrestigeSection() {
  const navigate = useNavigate();
  return (
    <section className="flex flex-col md:flex-row items-center justify-center min-h-screen px-8">
      <div className="flex-1 flex justify-center">
        <img
          src={img}
          alt="Luxury car interior"
          className="rounded-3xl w-full max-w-xl object-cover"
        />
      </div>

      <div className="flex-1 flex flex-col justify-center md:pl-16 mt-10 md:mt-0">
        <h2 className="text-4xl font-bold leading-tight text-black mb-6">
          Where Quality Meets Prestige
        </h2>
        <p className="text-lg text-gray-700 mb-10">
          Experience the pinnacle of luxury and performance with our exclusive
          car rental service. We offer a handpicked fleet of premium vehicles to
          ensure your journey is nothing short of extraordinary.
        </p>

        <div className="space-y-7 mb-10">
          <div className="flex items-start">
            <span className="flex items-center justify-center h-14 w-14  mr-5 mt-1">
              <svg
                width="63"
                height="68"
                viewBox="0 0 63 68"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="1.4502"
                  y="1.26514"
                  width="61"
                  height="65.8"
                  rx="7.5"
                  stroke="#FBBE06"
                />
                <path
                  d="M31.9502 20.1401C25.5299 20.1401 20.3252 25.3448 20.3252 31.7651C20.3252 38.1855 25.5299 43.3901 31.9502 43.3901C38.3705 43.3901 43.5752 38.1855 43.5752 31.7651C43.5752 25.3448 38.3705 20.1401 31.9502 20.1401ZM31.9502 22.3901C37.1314 22.3901 41.3252 26.5832 41.3252 31.7651C41.3252 36.9463 37.1322 41.1401 31.9502 41.1401C26.769 41.1401 22.5752 36.9471 22.5752 31.7651C22.5752 26.5839 26.7682 22.3901 31.9502 22.3901ZM38.5223 28.4964L37.4659 27.4315C37.2471 27.2109 36.891 27.2095 36.6704 27.4283L30.0445 34.0009L27.2418 31.1754C27.023 30.9549 26.6669 30.9534 26.4463 31.1722L25.3814 32.2286C25.1608 32.4474 25.1594 32.8035 25.3782 33.0241L29.6335 37.3139C29.8523 37.5345 30.2085 37.5359 30.429 37.3171L38.5191 29.2919C38.7396 29.0731 38.741 28.7169 38.5223 28.4964Z"
                  fill="#FBBE06"
                />
              </svg>
            </span>
            <div>
              <h3 className="font-bold text-2xl text-black mb-1">
                Trusted Service
              </h3>
              <p className="text-gray-500 text-base">
                Our experienced team is dedicated to providing you with
                seamless, reliable service from booking to return. We prioritize
                your satisfaction to ensure a smooth and enjoyable rental
                experience every time.
              </p>
            </div>
          </div>
          <div className="flex items-start">
            <span className="flex items-center justify-center h-14 w-14  mr-5 mt-1">
              <svg
                width="63"
                height="68"
                viewBox="0 0 63 68"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="1.4502"
                  y="1.26514"
                  width="61"
                  height="65.8"
                  rx="7.5"
                  stroke="#FBBE06"
                />
                <path
                  d="M31.9502 20.1401C25.5299 20.1401 20.3252 25.3448 20.3252 31.7651C20.3252 38.1855 25.5299 43.3901 31.9502 43.3901C38.3705 43.3901 43.5752 38.1855 43.5752 31.7651C43.5752 25.3448 38.3705 20.1401 31.9502 20.1401ZM31.9502 22.3901C37.1314 22.3901 41.3252 26.5832 41.3252 31.7651C41.3252 36.9463 37.1322 41.1401 31.9502 41.1401C26.769 41.1401 22.5752 36.9471 22.5752 31.7651C22.5752 26.5839 26.7682 22.3901 31.9502 22.3901ZM38.5223 28.4964L37.4659 27.4315C37.2471 27.2109 36.891 27.2095 36.6704 27.4283L30.0445 34.0009L27.2418 31.1754C27.023 30.9549 26.6669 30.9534 26.4463 31.1722L25.3814 32.2286C25.1608 32.4474 25.1594 32.8035 25.3782 33.0241L29.6335 37.3139C29.8523 37.5345 30.2085 37.5359 30.429 37.3171L38.5191 29.2919C38.7396 29.0731 38.741 28.7169 38.5223 28.4964Z"
                  fill="#FBBE06"
                />
              </svg>
            </span>
            <div>
              <h3 className="font-bold text-2xl text-black mb-1">
                Nationwide Reach
              </h3>
              <p className="text-gray-500 text-base">
                No matter where your travels take you, our nationwide network is
                ready to serve you. Enjoy the freedom to pick up and drop off
                your car at locations across the country, making travel more
                convenient than ever.
              </p>
            </div>
          </div>
        </div>

        <ButtonPrimary
          className="max-w-52"
          onClick={() => navigate("/")}
        >
          Rent Car Now
        </ButtonPrimary>
      </div>
    </section>
  );
}
